import { render } from "./BatchModal.vue?vue&type=template&id=1094e8b9&scoped=true"
import script from "./BatchModal.vue?vue&type=script&lang=js"
export * from "./BatchModal.vue?vue&type=script&lang=js"

import "./BatchModal.vue?vue&type=style&index=0&id=1094e8b9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1094e8b9"]])

export default __exports__